import type hashCode from '@/utils/hashCode/hashCode';
import {
  EntityRequestData,
  EntityResourceContainer,
} from '@/features/EntityManager/types';
import {
  type ClientResourceContainer,
  ClientResourceKeysWithNested,
  Role,
} from '@/features/Clients';

export const sparten = [
  'hun',
  'pfe',
  'pkw',
  'pkwv2',
  'unf',
  'res',
  'phv',
  'nutz',
  'nutzv2',
  'hau',
  'camp',
  'campv2',
  'krad',
  'kradv2',
  'woh',
  'pkv',
  'bu',
  'rlv',
] as const;

export type Sparte = (typeof sparten)[number];

export enum SPARTEN_STATUS {
  OK = 0,
  ERROR = 1,
}

export type SpartenStatusResponse = {
  [k in Sparte]: SPARTEN_STATUS;
};

export interface SearchDataEntity {
  refId: number;
  type: string;
  roles: Role[];
  data: Partial<Record<ClientResourceKeysWithNested, unknown>>;
}

export type SearchDataAllTimeTariffs = Record<string, unknown>;

export type Merkmale = Array<{ identifier: string; value: number }>;

export interface SearchData<
  T extends EntityResourceContainer = EntityResourceContainer,
  A = SearchDataAllTimeTariffs,
> {
  allTimeTariff?: A;
  entities: EntityRequestData<T>;
  eingabedaten: Record<string, unknown>;
  merkmale: Merkmale;
  blacklistedCompaniesHash: ReturnType<typeof hashCode>;
  migrationErrors?: string[];
}

export interface SearchDataComparable extends Omit<SearchData, 'entities'> {
  entities: Record<Role, ClientResourceContainer['data'] | undefined>;
}

export enum SEARCH_DATA_CONTEXT {
  TARIFF = 'tariff',
  OFFER = 'offer',
}
